<template>
  <div>
    <div v-if="!pageLoading">
      <back-nav to="CoverSummary" />
      <top-card current="BranchSelections" :cover-type="coverType" :instalments="installments"
        :premiumAmount="premiumAmount">
        Please select your preferred service branch
      </top-card>
      <v-card class="tw-mt-5 md:tw-mt-16 tw-py-1 md:tw-py-1">
        <v-form v-model="isValid">
          <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
            <div class="tw-w-full">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 ">You can now choose your ideal branch to
                handle your business</h3>
              <hr class="tw-mt-3 tw-mb-5">
            </div>
            <v-radio-group v-model="branchCode" v-if="!branchesLoading" :rules="[v => !!v || 'Branch is required']">
              <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-px-2 md:tw-px-8">
                <v-radio v-for="(branch, $index) in branches" :key="$index" :value="branch.code"
                  class="tw-px-2 md:tw-px-5 tw-mt-3 md:tw-mt-6">
                  <template #label>
                    <ul class="list-none">
                      <li>{{ branch.name }}</li>
                      <li class="tw-mt-1"><span class="c-blue-text">{{ branch.address }}</span></li>
                      <li>Open:{{ branch.openingTime }} Close:{{ branch.closingTime }}</li>
                      <li><span class="c-blue-text">{{ branch.tel }}</span></li>
                    </ul>
                  </template>
                </v-radio>
              </div>
            </v-radio-group>
            <div v-else class="tw-w-full tw-flex tw-justify-center">
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </div>

            <div v-if="coverType.covertypeId === 120" class="tw-px-4 md:tw-px-12 tw-mt-0 md:tw-mt-4 mb-3">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg mb-5">Vehicle Valuation & Assesment</h3><br/>

              <v-checkbox v-model="checked1" :rules="[check()]">
                <template #label>
                  <p class="c-gray-text">I agree to inspect my car within 14 days from the day of collection of insurance
                    certificate. If I fail to do so, my comprehensive policy plan will be downgraded to third party policy
                    plan</p>
                </template>
              </v-checkbox>
            </div>
            <div class="tw-px-4 md:tw-px-12 tw-mt-0">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg mb-5">Declaration & Authorization to obtain and use information
              </h3>
              <p class="c-gray-text">I confirm that the information given is correct and accurate. Your policy will be
                sold to you based on the information you provided. If the information provided is incorrect or incomplete,
                your policy could be cancelled, or a claim rejected/not paid in full.</p>
              <v-checkbox v-model="checked" :rules="[check()]">
                <template #label>
                  <terms-and-conditions pre="I have" post="of the policy & I agree to the same" />
                </template>
              </v-checkbox>
              <v-checkbox v-model="checked2" :rules="[check()]">
                <template #label>
                  <p class="c-gray-text">I Authorize APA Insurance to obtain and use my personal information. I also
                    confirm that I have read and understood the Apollo Group's privacy policy that can be accessed through
                    this link, <a href="https://www.apa.org/about/privacy" target="_blank" rel="noopener noreferrer">APA
                      Privacy Policy</a></p>
                </template>
              </v-checkbox>
            </div>

            <v-card-actions class="col-sm-6 offset-sm-3 tw-mt-5 md:tw-mt-8 tw-pb-8">
              <v-btn block large color="secondary" class="my-3 " :loading="loading" :disabled="!isValid" @click="proceed">
                {{ isValid ? 'Proceed To Payment' : 'Check if all fields are filled' }}
              </v-btn>
            </v-card-actions>
          </div>
        </v-form>
      </v-card>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
    </div>
  </div>
</template>

<script>
import TopCard from '@/components/buy/TopCard';
import TermsAndConditions from '@/components/TermsAndConditions';
import BackNav from '@/components/buy/BackNav';
import { mapGetters } from 'vuex';
import axios from 'axios';
import validations from '@/utils/validations';
import { FB_BUY_PICKUP_LOCATION } from '@/utils/const';
import {
  changeFormat, formatDate, reverseFormat, timeNow,
} from '@/utils/time';

export default {
  name: 'BranchSelections',
  components: { BackNav, TermsAndConditions, TopCard },
  data() {
    return {
      loading: false,
      pageLoading: true,
      branchesLoading: true,
      branches: [],
      isValid: false,
      ...validations,
      branchCode: '',
      branchCode1: '',
      checked: '',
      checked1: '',
      checked2: '',
      date: '',
      menu: false,
      time: null,
      menu2: false,
      quote: '',
      benefit: '',
      registrationNumber: 'KDZ 435Y',
    };
  },
  computed: {
    ...mapGetters('rfq', ['getQoute']),
    coverType() {
      return this.quote.covertypes.find((e) => e.riskId === this.benefit);
    },
    installments() {
      return this.quote?.instalments;
    },
    premiumAmount() {
      return this.installments?.reduce((sum, installment) => sum + installment.premium, 0);
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  metaInfo: {
    title: 'Buy - Branch Selection',
  },
  mounted() {
    this.quote = this.getQoute;
    const quote = this.$route.query.q;
    this.benefit = parseInt(this.$route.query.b, 10);
    this.$store.dispatch('rfq/getQuotation', quote).then(() => {
      if ('mainBranchCode' in this.getQoute) this.branchCode = parseInt(this.getQoute.mainBranchCode, 10);
      if ('branch' in this.getQoute) {
        this.checked = true;
        this.checked1 = true;
        const { branch } = this.getQoute;
        this.branchCode1 = parseInt(branch.code, 10);
        this.time = branch.pickupTime;
        this.date = branch.pickupDate !== '' ? new Date(this.reverseFormat(branch.pickupDate.replace('-', '/'))).toISOString().substring(0, 10) : '';
      }
      this.pageLoading = false;
    });
    this.getBranches();
  },
  methods: {
    async proceed() {
      this.loading = true;
      const {
        engineNumber, entertainmentSysValue, windscreenValue, registrationNumber, ...carData
      } = {
        ...this.coverType.car,
        ...{
          carId: 0,
          benefits: [],
          covertypeId: this.coverType.covertypeId,
          evaluationSelected: 2131362803,
          riskId: parseInt(this.benefit, 10),
          vehicleImages: [],
          engineNo: this.coverType?.car?.engineNumber ?? '',
          valueOfEntertainmentScreen: this.coverType?.car?.entertainmentSysValue ?? '',
          valueOfWindScreen: this.coverType?.car?.windscreenValue ?? '',
        },
      };
      carData.registrationNumber = this.coverType?.car?.registrationNumber ?? '';
      const data = {
        addressLine1: '1245',
        bankAccount: this.getQoute.client.bankAccount,
        bankBranch: this.getQoute.client.bankBranch,
        bankName: this.getQoute.client.bankName,
        coverFrom: this.changeFormat(this.getQoute.coverFrom),
        dateFormat: 'dd/MM/yyyy',
        documents: this.getQoute.document,
        email: this.getQoute.client.email,
        fullName: this.getQoute.client.fullName,
        idNumber: this.getQoute.client.idNumber,
        kraPinNumber: this.getQoute.client.kraPinNumber,
        mobileNumber: this.getQoute.client.mobileNumber,
        pinNumber: this.getQoute.client.kraPinNumber,
        poBoxNo: this.getQoute.client.poBoxNo,
        postalCode: this.getQoute.client.postalCode,
        gender: this.getQoute.client.gender,
        carDTOS: [carData],
        prodId: this.coverType.productCode,
        quoteId: parseInt(this.quote.quoteId, 10),
        selectedRiskId: parseInt(this.benefit, 10),
        paymentStatus: false,
        dlImage: {
          dlImageId: 0,
          backImageUrl: '',
          frontImageUrl: '',
        },
        premium: this.coverType?.riskPremDto?.totalPremium ?? 0,
        privateCover: false,
        planChanged: false,
        paymentType: 'MONTHLY',
        addressLine2: this.getQoute.client.postalCode,
        coverTypeID: this.coverType.covertypeId,
        status: 0,
        timestamp: 0,
        branchCode: this.branchCode,
      };
      await axios.post('customer/quotation/policy/create', data)
        .then(async (response) => {
          if (response.data.success) {
            this.$analytics.logEvent(FB_BUY_PICKUP_LOCATION);
            this.$emit('to-payment-selection');
          } else {
            this.$toast.error('An Error occurred, try again !', 'Selections');
          }
          this.loading = false;
        });
    },
    getBranches() {
      axios.get('/customer/gis/branches/retrieveAll')
        .then((response) => {
          this.branches = response.data.object;
          this.branchesLoading = false;
        });
    },
    changeFormat,
    formatDate,
    reverseFormat,
    timeNow,
    allowedDates: (val) => ![0, 6].includes(new Date(val).getDay()),
    allowedHours: (val) => ![0, 1, 2, 3, 4, 5, 6, 7, 18, 19, 20, 21, 22, 23, 24].includes(val),
  },
};
</script>
